import _ from 'underscore';

import * as EventConstants from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import Store from 'lib/Store';
import * as RegistryUtil from 'registry/RegistryUtil';

class FileBrowserStore extends Store {
  // Only purpose of this is to set fileStates once everything is initialized (fileStates is needed in
  // multiple places, so better to set here than at every use)
  setFileStates(fileStates) {
    this.fileStates = fileStates;
  }

  resetState() {
    this.recents = null;
  }

  getState() {
    return {
      recents: this.recents,
    };
  }

  payloadHandler(action) {
    switch (action.actionType) {
      case EventConstants.FILE_BROWSER_RECENTS_FETCHED:
        ({recents: this.recents} = action);
        this.emitChange();
        break;

      case EventConstants.FILE_BROWSER_RENAME_FILE: {
        // Update filestate with the new name as long as it isn't a proxy file, which will handle itself.
        const {id, name, displayLabel} = action;
        const fileState = this.fileStates.get(id);
        if (fileState != null && !(fileState instanceof this.fileStates.constructor.ProxyFileState)) {
          fileState.model().setNameAndDisplayLabel(name, displayLabel);
        }
        break;
      }

      case EventConstants.FILE_BROWSER_MOVE_FILES_COMPLETED: {
        // Update filestates with the new folder as long as they aren't
        // proxy files, which will handle themselves.
        const {ids, folder} = action;
        // eslint-disable-next-line no-restricted-syntax
        _.each(ids, (id) => {
          const fileState = this.fileStates.get(id);
          if (fileState != null && !(fileState instanceof this.fileStates.constructor.ProxyFileState)) {
            if (RegistryUtil.isRegistry(folder.source)) {
              fileState.model().syncProjectFolder(fileState.model().folder());
            }
            fileState.model().setFolder(folder);
          }
        });
        break;
      }

      case EventConstants.FILE_BROWSER_MOVE_SHORTCUTS_COMPLETED: {
        // Update filestates with the new folder as long as they aren't
        // proxy files, which will handle themselves.
        const {ids, folder} = action;
        // eslint-disable-next-line no-restricted-syntax
        _.each(ids, (id) => {
          const fileState = this.fileStates.get(id);
          if (fileState != null && !(fileState instanceof this.fileStates.constructor.ProxyFileState)) {
            fileState.model().syncProjectFolder(folder);
          }
        });
        break;
      }

      case EventConstants.FILE_BROWSER_UNREGISTER_FILES: {
        // Update filestates by clearing projectFolder as long as they aren't proxy files
        const {ids} = action;
        // eslint-disable-next-line no-restricted-syntax
        _.each(ids, (id) => {
          const fileState = this.fileStates.get(id);
          if (fileState != null && !(fileState instanceof this.fileStates.constructor.ProxyFileState)) {
            fileState.model().clearProjectFolder();
          }
        });
        break;
      }

      default:
        break;
    }

    return true;
  }
}

export default new FileBrowserStore(AppDispatcher);
